import React, { useContext } from 'react';
import styled from 'styled-components';

import FloorboardRow from './floorboard_row';
import { getBrandIconByName } from 'components/common/custom_channels';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function CustomChannelRow({ customChannel }) {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = ((channel && channel.customChannels) || {})[customChannel.id] || {};
  const customChannelSla = ((sla && sla.customChannels) || {})[customChannel.id] || { over: 0, total: 0 };
  const { icon } = getBrandIconByName(customChannel.icon, { letter: customChannel.name, color: 'black' });

  return (
    <FloorboardRow
      activeItems={stats.currentOpenMessages}
      activeLabel="Open Messages"
      currentWait={stats.currentWait}
      icon={<CustomChannelIcon>{icon}</CustomChannelIcon>}
      newItems={stats.currentNewMessages}
      newLabel="New Messages"
      sla={customChannelSla}
      waitLabel="Oldest Unanswered Message"
    />
  );
}

const CustomChannelIcon = styled.div`
  display: flex;
  align-items: center;
  && .customChannel-brand-icon {
    height: auto;
    width: 3vw;
    fill: ${p => p.theme.colors.white};
  }
`;
